/**
 * Кнопка виджета Telegram Login (официальный скрипт telegram.org). Показывается гостю в браузере, когда сервер отдал
 * имя бота (`registerTelegramLogin`). Скрипт кладёт iframe с кнопкой на место тега `<script>`; результат приходит в
 * глобальный колбэк `data-onauth`.
 */
import type { AuthTelegramLoginRequest } from "@newfungame/contracts";
import { useEffect, useRef } from "preact/hooks";
import { shallowEqual, useStore } from "./hooks";
import { slotStore } from "./slots";
import { appStore } from "./store";

const WIDGET_SRC = "https://telegram.org/js/telegram-widget.js?22";

declare global {
  interface Window {
    nfgTelegramLogin?: (data: AuthTelegramLoginRequest) => void;
  }
}

/** Место под вход (`eligible`): браузер, гость, вход завершён. Кнопка (`login`) — ещё и если бот известен. */
export function useTelegramLogin() {
  const login = useStore(slotStore, (s) => s.telegramLogin);
  const { guest, miniApp, ready } = useStore(
    appStore,
    (s) => ({ guest: s.auth.guest, miniApp: s.miniApp, ready: s.auth.status === "ready" }),
    shallowEqual,
  );
  const eligible = !miniApp && guest && ready;
  return { eligible, login: eligible ? login : null };
}

export function TelegramLoginButton({
  bot,
  onAuth,
}: {
  bot: string;
  onAuth: (data: AuthTelegramLoginRequest) => void;
}) {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = host.current;
    if (!el) return;
    window.nfgTelegramLogin = onAuth;
    const script = document.createElement("script");
    script.async = true;
    script.src = WIDGET_SRC;
    script.dataset.telegramLogin = bot;
    script.dataset.size = "medium";
    script.dataset.userpic = "false";
    script.dataset.requestAccess = "write";
    script.dataset.onauth = "nfgTelegramLogin(user)";
    el.append(script);
    return () => {
      el.replaceChildren();
      if (window.nfgTelegramLogin === onAuth) delete window.nfgTelegramLogin;
    };
  }, [bot, onAuth]);
  return <div class="tg-login" data-testid="telegram-login" ref={host} />;
}
